import example from './components/example';

example();